import {
  SET_REPORT_DIAGNOSIS_DATA,
  SET_CATEGORIZED_DATA,
  SET_REPORT_COMMENTS_DATA,
  SET_TRF_INFO,
  GET_CASE_DATA,
  SET_SLIDE_DIAGNOSIS_OPTIONS,
  SET_IMAGE_QUALITY_OPTIONS,
  SELECT_IMAGE_FOR_REPORT,
  SET_SHOWING_RECT,
  ADD_SAMPLE_LOCATION_DATA,
  ADD_SUMMARY_TREE_DATA,
  ADD_BARCODE_DATA,
  SET_ALL_SLIDES,
  ADD_CLINICAL_INFO,
  SAVE_SLIDE_DIAGNOSIS_SUCCESS,
  SAVE_SLIDE_DIAGNOSIS_ERROR,
  GET_SLIDE_DIAGNOSIS,
  GET_REPORT_HISTORY,
  SET_REPORT_DATA,
  SET_REPORT_COMMENT_OBJECTS_DATA,
  SET_PATIENT_HISTORY,
  UPDATE_PATIENTHISTORY_FETCH_INPROGRESS,
  GET_CPT_CODES,
  SAVE_REPORT_DATA,
  SAVE_REPORT_DRAFT_SUCCESS,
  SAVE_REPORT_DRAFT_ERROR,
  SET_DRAFT_REPORT,
  GET_PDF_BYTES,
  GET_PREMERIS_REGIONS,
  CONSULT_CASE_SUCCESS,
  CONSULT_CASE_ERROR,
  ADD_PATHOLOGISTS_LIST,
  EMPTY_PATHOLOGISTS_LIST,
  CONSULT_COMPLETE_SUCCESS,
  CONSULT_COMPLETE_ERROR,
  ADD_PATHOLOGIST_NAMES_LIST,
  SAVE_REPORT_SUCCESS,
  SAVE_REPORT_ERROR,
  SAVE_REPORT_RESET,
  AMEND_REPORT_SUCCESS,
  AMEND_REPORT_ERROR,
  UPLOAD_REPORT_SUCCESS,
  UPLOAD_REPORT_ERROR,
  UPLOAD_REPORT_RESET,
  SET_REPORT_URL,
  SET_CASE_DIAGNOSIS,
  SET_SIGNED_URL_TO_SAVE_REPORT,
  SET_TRF_URL,
  SET_UPLOAD_URL,
  GET_SAVE_STATE,
  REFRESH_CASE,
  REFRESH_CASE_SUCCESS,
  REFRESH_CASE_ERROR,
  UPDATE_REFRESH_INPROGRESS,
  AUDIT_CLASSIFIER,
} from '../../actions'

export const setReportDiagnosisDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_DIAGNOSIS_DATA:
      return { ...action.payload }
    default:
      return state
  }
}

export const setCategorizedDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_CATEGORIZED_DATA:
      return { ...action.payload }
    default:
      return state
  }
}

export const setReportCommentsDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_COMMENTS_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

export const setCommentObjectsListDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_COMMENT_OBJECTS_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

export const addTrfInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_TRF_INFO:
      return { ...action.payload }

    default:
      return state
  }
}

const initialRefreshState = {
  fetchInProgress: false,
}

export const refreshCaseReducer = (state = initialRefreshState, action) => {
  switch (action.type) {
    case REFRESH_CASE:
      return { ...action.payload }
    case UPDATE_REFRESH_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}
const refreshCaseAction = {
  refresh_success: false,
  refresh_error: false,
}
export const refreshCaseResponseReducer = (state = refreshCaseAction, action) => {
  switch (action.type) {
    case REFRESH_CASE_SUCCESS:
      return { ...state, refresh_success: true, refresh_error: false }
    case REFRESH_CASE_ERROR:
      return { ...state, refresh_success: false, refresh_error: true }

    default:
      return state
  }
}
export const setSlideDiagnosisOptionsReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_SLIDE_DIAGNOSIS_OPTIONS:
      return { ...action.payload }

    default:
      return state
  }
}

export const setImageQualityOptionsReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_IMAGE_QUALITY_OPTIONS:
      return { ...action.payload }

    default:
      return state
  }
}

export const getCaseDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CASE_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

export const selectImageForReportReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECT_IMAGE_FOR_REPORT: {
      let barcodeForUse = action.payload.slideBarcode
      let useOriginalBarcodeToo = false

      if (barcodeForUse.indexOf('04') > -1) {
        useOriginalBarcodeToo = true

        const cellBlockParent = Object.values(state[action.payload.trfBarcode]).filter(
          (item) => !item.ParentID && item.SampleBarcode.toLowerCase().indexOf('01') === -1,
        )[0]
        barcodeForUse = cellBlockParent.SampleBarcode.toLowerCase()
      }

      // If barcode for use does not have selectedImages array, add it
      // eslint-disable-next-line
      if (!state[action.payload.trfBarcode][barcodeForUse].selectedImages) {
        state[action.payload.trfBarcode][barcodeForUse].selectedImages = []
      }

      // If use original barcode too and it does NOT have selectedImages array, add it
      if (useOriginalBarcodeToo && !state[action.payload.trfBarcode][action.payload.slideBarcode].selectedImages) {
        state[action.payload.trfBarcode][action.payload.slideBarcode].selectedImages = []
      }

      // Add newly selected image to BEGINNING of array
      const { selectedImages } = state[action.payload.trfBarcode][barcodeForUse]
      selectedImages.unshift(action.payload.image)

      if (useOriginalBarcodeToo) {
        state = {
          ...state,
          [action.payload.trfBarcode]: {
            ...state[action.payload.trfBarcode],
            [barcodeForUse]: {
              ...state[action.payload.trfBarcode][barcodeForUse],
              selectedImages,
              imageToAppearOnReport: 'user',
            },
            [action.payload.slideBarcode]: {
              ...state[action.payload.trfBarcode][action.payload.slideBarcode],
              selectedImages,
              imageToAppearOnReport: 'user',
            },
          },
        }
      } else {
        state = {
          ...state,
          [action.payload.trfBarcode]: {
            ...state[action.payload.trfBarcode],
            [barcodeForUse]: {
              ...state[action.payload.trfBarcode][barcodeForUse],
              selectedImages,
              imageToAppearOnReport: 'user',
            },
          },
        }
      }
      return state
    }
    default:
      return state
  }
}

export const setShowingRectReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_SHOWING_RECT:
      // action.payload.whichRectSet - regular or blue rect
      // action.payload.clid - clid of chosen rect
      // eslint-disable-next-line
      const whichRectSet = action.payload.whichRectSet === 'reg' ? 'showingPremerisRects' : 'showingBluePremerisRects'
      state = {
        ...state,
        [whichRectSet]: [...state[whichRectSet], action.payload.clid],
      }
      return state
    default:
      return state
  }
}

export const addSampleLocationDataReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_SAMPLE_LOCATION_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

export const addSummaryTreeDataReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_SUMMARY_TREE_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

export const addBarcodeDataReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_BARCODE_DATA:
      return { ...action.payload, error: action.error }

    default:
      return state
  }
}

export const addClinicalInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_CLINICAL_INFO:
      return { ...action.payload }

    default:
      return state
  }
}
const saveSlideDiagnosis = {
  re_save_success: false,
  re_save_error: false,
}

export const saveSlideDiagnosisDataReducer = (state = saveSlideDiagnosis, action) => {
  switch (action.type) {
    case SAVE_SLIDE_DIAGNOSIS_SUCCESS:
      return { ...state, re_save_success: true, re_save_error: false }
    case SAVE_SLIDE_DIAGNOSIS_ERROR:
      return { ...state, re_save_success: false, re_save_error: true }

    default:
      return state
  }
}

export const getSlideDiagnosisDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_SLIDE_DIAGNOSIS:
      return { ...action.payload }

    default:
      return state
  }
}

export const getReportHistoryDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_REPORT_HISTORY:
      return { ...action.payload }

    default:
      return state
  }
}

export const setReportDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_DATA:
      return { ...action.payload }

    default:
      return state
  }
}
const defaultState = {
  historyData: {},
  fetchHistoryInProgress: false,
}
export const setPatientHistoryReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_PATIENT_HISTORY:
      return { ...state, historyData: action.payload }
    case UPDATE_PATIENTHISTORY_FETCH_INPROGRESS:
      return { ...state, fetchHistoryInProgress: action?.inProgress }
    default:
      return state
  }
}

export const setAllSlidesReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_ALL_SLIDES:
      const {
        payload: { allSlides, previousTrfBarcode },
      } = action
      let stateCopyWithoutPreviousTrfBarcode = { ...state }

      if (previousTrfBarcode && action.payload.trfBarcode && previousTrfBarcode !== action.payload.trfBarcode) {
        delete stateCopyWithoutPreviousTrfBarcode[previousTrfBarcode]
      }

      // If trfBarcode does not exist on the state obj, add it
      if (!Object.prototype.hasOwnProperty.call(stateCopyWithoutPreviousTrfBarcode, action.payload.trfBarcode)) {
        stateCopyWithoutPreviousTrfBarcode = {
          ...stateCopyWithoutPreviousTrfBarcode,
          [action.payload.trfBarcode]: {},
        }
      }

      if (allSlides.length) {
        const helperObj = {}
        allSlides.forEach((item) => {
          const barcode = Object.keys(item)[0]
          // If the barcode DOES NOT already exist within the TRFBarcode object:
          if (
            !Object.prototype.hasOwnProperty.call(
              stateCopyWithoutPreviousTrfBarcode[action.payload.trfBarcode],
              barcode,
            )
          ) {
            helperObj[barcode] = {
              SampleStain: Object.values(item)[0],
            }
          }
        })
        state = {
          ...stateCopyWithoutPreviousTrfBarcode,
          allSlides,
          [action.payload.trfBarcode]: {
            ...helperObj,
            ...stateCopyWithoutPreviousTrfBarcode[action.payload.trfBarcode],
          },
        }
      } else {
        state = {
          ...stateCopyWithoutPreviousTrfBarcode,
        }
      }
      return state
    default:
      return state
  }
}

export const getCPTCodesDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CPT_CODES:
      return { ...action.payload }
    default:
      return state
  }
}

export const getPDFBytesReducer = (state = [], action) => {
  switch (action.type) {
    case GET_PDF_BYTES:
      return { ...action.payload }
    default:
      return state
  }
}

const saveDraft = {
  re_save_draft_success: false,
  re_save_draft_error: false,
}

export const saveDraftReportReducer = (state = saveDraft, action) => {
  switch (action.type) {
    case SAVE_REPORT_DRAFT_SUCCESS:
      return { ...state, re_save_draft_success: true, re_save_draft_error: false }
    case SAVE_REPORT_DRAFT_ERROR:
      return { ...state, re_save_draft_success: false, re_save_draft_error: true }
    default:
      return state
  }
}

const saveReportData = {
  re_saveReportData_success: false,
  re_saveReportData_error: false,
}

export const saveReportDataResponseReducer = (state = saveReportData, action) => {
  switch (action.type) {
    case SAVE_REPORT_SUCCESS:
      return { ...state, re_saveReportData_success: true, re_saveReportData_error: false }
    case SAVE_REPORT_ERROR:
      return { ...state, re_saveReportData_success: false, re_saveReportData_error: true }
    case SAVE_REPORT_RESET:
      return saveReportData
    default:
      return state
  }
}

const amendReportData = {
  re_amendReport_success: false,
  re_amendReport_error: false,
}

export const amendReportUploadReducer = (state = amendReportData, action) => {
  switch (action.type) {
    case AMEND_REPORT_SUCCESS:
      return { ...state, re_amendReport_success: true, re_amendReport_error: false }
    case AMEND_REPORT_ERROR:
      return { ...state, re_amendReport_success: false, re_amendReport_error: true }
    default:
      return state
  }
}

export const setDraftReportDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_DRAFT_REPORT:
      return { ...action.payload }

    default:
      return state
  }
}

const consultCase = {
  re_consult_success: false,
  re_consult_error: false,
}

export const consultResponseReducer = (state = consultCase, action) => {
  switch (action.type) {
    case CONSULT_CASE_SUCCESS:
      return { ...state, re_consult_success: true, re_consult_error: false }
    case CONSULT_CASE_ERROR:
      return { ...state, re_consult_success: false, re_consult_error: true }

    default:
      return state
  }
}

const consultComplete = {
  re_consultComplete_success: false,
  re_consultComplete_error: false,
}

export const consultCompleteResponseReducer = (state = consultComplete, action) => {
  switch (action.type) {
    case CONSULT_COMPLETE_SUCCESS:
      return { ...state, re_consultComplete_success: true, re_consultComplete_error: false }
    case CONSULT_COMPLETE_ERROR:
      return { ...state, re_consultComplete_success: false, re_consultComplete_error: true }

    default:
      return state
  }
}

const pathologistsList = {
  re_pathologistsList_success: false,
  re_pathologistsList_error: false,
}

export const getPathologistsListResponseReducer = (state = pathologistsList, action) => {
  switch (action.type) {
    case EMPTY_PATHOLOGISTS_LIST:
      return { ...state, re_pathologistsList_success: false, re_pathologistsList_error: true }
    case ADD_PATHOLOGISTS_LIST:
      return { ...state, re_pathologistsList_success: true, re_pathologistsList_error: false }
    default:
      return state
  }
}

export const getPathologistsListReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_PATHOLOGIST_NAMES_LIST:
      return { ...state, ...action.payload }
    default:
      return state
  }
}

export const setSignedUrlToGetReportReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_REPORT_URL:
      return { ...action.payload }

    default:
      return state
  }
}

export const setCaseDiagnosisReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_CASE_DIAGNOSIS:
      return { ...action.payload }

    default:
      return state
  }
}

export const setSignedURLToSaveReportReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_SIGNED_URL_TO_SAVE_REPORT:
      return { ...action.payload }

    default:
      return state
  }
}

export const setSignedUrlToGetTrfReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_TRF_URL:
      return { ...action.payload }

    default:
      return state
  }
}

export const setURLForReportPDFReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_UPLOAD_URL:
      return { ...action.payload }

    default:
      return state
  }
}

export const getSaveStateReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_SAVE_STATE:
      return { ...action.payload }

    default:
      return state
  }
}
export const auditClassifierAccessedReducer = (state = {}, action) => {
  switch (action.type) {
    case AUDIT_CLASSIFIER:
      return { ...action.payload }

    default:
      return state
  }
}
